import { hydrate } from '@solidjs/web';
import { DefaultErrorBoundary } from "virtual:solid-ssr-error-boundary.tsx";
import Document from "/app/src/Document.tsx";
import App from "/app/src/App.tsx";

hydrate(() => (
  <DefaultErrorBoundary>
    <Document>
      <DefaultErrorBoundary>
        <App />
      </DefaultErrorBoundary>
    </Document>
  </DefaultErrorBoundary>
), document);